"use client"; // Error boundaries must be Client Components

import { Button, LinkButton, TabsIcon } from "@procision-software/ui";
import { HomeIcon, OctagonAlert, RefreshCwIcon } from "lucide-react";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => console.error(JSON.stringify(error)), [error]);

  return (
    <div className="flex flex-1 flex-col gap-4 p-2 sm:flex-row sm:items-center sm:justify-center sm:gap-12 sm:p-12">
      <TabsIcon className="hidden h-auto max-w-full sm:block" />
      <div className="flex flex-col justify-center gap-4 sm:gap-12">
        <h1 className="flex items-center gap-1 text-error">
          <OctagonAlert className="h-7 w-7" /> Error
        </h1>
        <p className="text-error">{error instanceof Error ? error.message : error.toString()}</p>
        <div className="flex items-center gap-4">
          <Button variant="primary" outline={true} onClick={reset} leftIcon={RefreshCwIcon}>
            Reset
          </Button>
          <LinkButton variant="secondary" outline={true} href="/" leftIcon={HomeIcon}>
            Go home
          </LinkButton>
        </div>
      </div>
    </div>
  );
}
